import { prompt, type PromptDefinition } from './models';

export const COMPLIANCE_OFFICER_PROMPTS = [
    prompt(
        'Meet obligations',
        'Which compliance items are due or overdue in this building?',
        'Which buildings have compliance items due or overdue?'
    ),
    prompt(
        'Meet obligations',
        'Which obligations in this building lack current compliance evidence?',
        'Which buildings have the most significant compliance evidence gaps?'
    ),
    prompt(
        'Meet obligations',
        'What open compliance findings need follow-up in this building?',
        'Which buildings have unresolved compliance findings to prioritise?'
    ),
    prompt(
        'Meet obligations',
        'Find compliance certificates for this building relating to…',
        'Find compliance certificates across my buildings relating to…',
        'prefill'
    ),
    prompt(
        'Meet obligations',
        'Which inspection results in this building are marked non-compliant?',
        'Compare recorded non-compliant inspection findings across my buildings.'
    ),
    prompt(
        'Meet obligations',
        "What evidence verifies closure of this building's compliance actions?",
        'Which buildings have compliance actions closed without verification evidence?'
    ),
    prompt(
        'Meet obligations',
        "Which requirements in this building's compliance schedule lack a responsible person?",
        'Which buildings have compliance requirements without recorded ownership?'
    ),
    prompt(
        'Meet obligations',
        'Find compliance inspection evidence for this building covering…',
        'Find compliance inspection evidence across my buildings covering…',
        'prefill'
    ),
    prompt(
        'Meet obligations',
        "Where do this building's compliance schedules and certificates disagree?",
        'Which buildings have inconsistencies between compliance schedules and certificates?'
    ),
    prompt(
        'Meet obligations',
        'Which compliance records for this building may need renewal?',
        'Which buildings have compliance records expiring in the next review period?'
    ),
    prompt(
        'Meet obligations',
        "What is missing from this building's compliance audit trail?",
        'Compare compliance audit-trail gaps across my buildings.'
    ),
    prompt(
        'Meet obligations',
        'Prepare a compliance evidence summary for this building about…',
        'Prepare a compliance exceptions summary across my buildings about…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
